import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';
import UseCandidatesList from 'cms/features/feature_job/hooks/UseCandidatesList';
import CandidatePeopleCard from './CandidatePeopleCard';

function CandidatesList({ filters = {}, onLoadingChange }) {
    const navigate = useNavigate();
    const { data, isLoading, isError, isFetching } = UseCandidatesList({ size: 30, filters });

    useEffect(() => {
        if (onLoadingChange) onLoadingChange(isLoading || isFetching);
    }, [isLoading, isFetching, onLoadingChange]);

    const candidates = data?.results || [];
    const totalCount = data?.count || 0;

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return <Alert severity="error" sx={{ mt: 1 }}>Failed to load candidates. Please try again later.</Alert>;
    }

    if (candidates.length === 0) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8, gap: 1 }}>
                <PeopleIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
                <Typography variant="body1" color="text.secondary">
                    No candidates found. Try adjusting your filters.
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" fontWeight={500} sx={{ mb: 2 }}>
                {totalCount} candidate{totalCount !== 1 ? 's' : ''} found
            </Typography>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 270px), 1fr))',
                    gap: 2,
                }}
            >
                {candidates.map((candidate) => (
                    <Box
                        key={candidate.id}
                        sx={{ width: '100%', minWidth: 0, display: 'flex' }}
                    >
                        <CandidatePeopleCard
                            candidate={candidate}
                            onCardClick={() => navigate(`/candidate/${candidate.id}`)}
                            onPrimaryClick={() => navigate(`/candidate/${candidate.id}`)}
                            primaryLabel="View profile"
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default CandidatesList;
